<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="note ? note.title : ''"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-row class="mb-4">
          <b-col>
            <div class="bold-text main-color">
              Animal
            </div>
            <div class="mt-2" v-if="note">
              <b-link :to="{name: 'AnimalShow', params: {animalId: note.animal.id}}">
                {{ note.animal.name }}
              </b-link>
            </div>
          </b-col>
          <b-col>
            <div class="bold-text main-color">
              Hospitalisation
            </div>
            <div class="mt-2" v-if="note">
              <b-link :to="{ name: 'HospitalizationShow', params: { hospitalizationId: note.hospitalization.id }}">
                Hospitalisation du {{new Date(note.hospitalization.startDate).toLocaleDateString('fr-FR')}} (#{{note.hospitalization.id}})
              </b-link>
            </div>
          </b-col>
        </b-row>
        <div class="bold-text main-color" v-if="note && note.description">
          Message
        </div>
        <div class="multiline mb-4" v-if="note && note.description">
          {{ note.description }}
        </div>

        <div v-if="note && note.fileName != null">

          <img
            v-if="note.isPhoto && imageSrc"
            :src="imageSrc"
            @click="zoomOnImage(imageSrc)"
            alt="Photo associée à la note"
            class="note-img"
          >

          <b-embed
            v-if="note.isVideo && videoSrc"
            class="mt-2 note-video"
            type="video"
            aspect="16by9"
            controls
          >
            <source :src="videoSrc">
          </b-embed>
        </div>

      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <note-delete-modal :selected="note" @didDeleteNote="didDeleteNote()"></note-delete-modal>

    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import NoteDeleteModal from "./NoteDeleteModal";
import ZoomOnImage from "../../components/ZoomOnImage";

export default {

  name: 'NoteShow',

  components: {
    BackArrow,
    ShowActions,
    NoteDeleteModal,
    ZoomOnImage
  },

  data() {
    return {
      noteId: this.$route.params.noteId,
      note: null,
      imageSrc: null,
      videoSrc: null,
      ui: {
        zoomOnImageSrc: null
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      await this.fetchNote()
    },

    async fetchNote() {
      try {
        const response = await api.get(`/note/${this.noteId}`)
        this.note = response.data

        if (this.note && this.note.fileName && this.note.fileUrl) {
          if (this.note.isPhoto) {
            await this.loadMediaPreview(this.note.fileUrl, true)
          } else if (this.note.isVideo) {
            await this.loadMediaPreview(this.note.fileUrl, false)
          }
        }
      } catch (e) {
        console.error('fetchNote error', e)
      }
    },

    async loadMediaPreview(fileUrl, isPhoto) {
      try {
        const res = await api.get(fileUrl, {
          responseType: 'blob'
        })

        const ct = (res.headers && res.headers['content-type']) || ''

        if (isPhoto && !ct.startsWith('image/')) {
          throw new Error('La réponse n\'est pas une image (content-type=' + ct + ')')
        }

        const blobUrl = window.URL.createObjectURL(res.data)

        if (isPhoto) {
          this.imageSrc = blobUrl
        } else {
          this.videoSrc = blobUrl
        }
      } catch (e) {
        console.error('loadMediaPreview error', e)
      }
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'NoteEdit',
        params: {
          noteId: this.note.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('note-delete-modal')
    },

    didDeleteNote() {
      this.$router.push({
        name: 'NoteIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`Note \"${this.note.title}\" supprimée`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    }
  },

  beforeDestroy() {
    if (this.imageSrc) {
      window.URL.revokeObjectURL(this.imageSrc)
    }
    if (this.videoSrc) {
      window.URL.revokeObjectURL(this.videoSrc)
    }
  }
}
</script>

<style scoped>
.note-img {
  max-height: 400px;
  max-width: 400px;
}
.note-video {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/note/NoteShow.vue